<template>
  <b-nav
    id="footer"
    class="navbar navbar-expand fixed-bottom navbar-dark bg-dark"
  >
    <div class="navbar-nav mx-auto small">
      <a
        class="nav-item nav-link"
        target="_blank"
        rel="noopener noreferrer"
        :href="brand.footer.contactUrl"
      >
        {{ t("contact") }}
      </a>
      <span class="navbar-text px-2">|</span>
      <a
        class="nav-item nav-link"
        target="_blank"
        rel="noopener noreferrer"
        :href="brand.footer.privacyUrl[locale]"
      >
        {{ t("privacy_notice") }}
      </a>
      <span class="navbar-text px-2">|</span>
      <a
        class="nav-item nav-link"
        target="_blank"
        rel="noopener noreferrer"
        :href="brand.footer.imprintUrl[locale]"
      >
        {{ brand.footer.imprintText[locale] }}
      </a>
      <span class="navbar-text px-2">|</span>
      <b-nav-text> {{ custom.windowTitle }} </b-nav-text>
    </div>
  </b-nav>
</template>

<i18n>
  en:
    contact: "Contact"
    privacy_notice: "Privacy Notice"
  de:
    contact: "Kontakt"
    privacy_notice: "Datenschutz"
</i18n>

<script setup>
import { useI18n } from 'vue-i18n'

import { brand } from "@/brand/brand";
import { custom } from "@/customization/customization";

const { t, locale } = useI18n()
</script>

<style scoped>
/* Abstand zum Inhalt oberhalb */
#footer {
  height: 30px;
}
</style>
